import React, { useEffect } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import { Typography } from "@progress/kendo-react-common";
import ShadowCard from "../../../components/common/ShadowCard";
import {
  clearExpenseSummaryReportDetails,
  clearExpenseSummaryReportList,
  setExpenseSummaryReport,
} from "../reportsSlice";
import AlertBox from "../../../components/common/AlertBox";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Button } from "@progress/kendo-react-buttons";
import {
  // calculateTotalRow,
  checkAcessRights,
  formatIndianNumber,
  // getUnitTypes,
} from "../../../_helper/helper";
import {
  EDIT_ACCESS,
  EXCEL_EXPORT_ACCESS,
  PRINT_ACCESS,
} from "../../../_contstants/common";
import { getAllExpenseSummaryReport } from "../services/reports.services";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { BsThreeDotsVertical } from "react-icons/bs";
import { RxCross2 } from "react-icons/rx";
import FormCheckboxGroup from "../../../components/formFields/FormCheckboxGroup";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import FormDatePicker from "../../../components/formFields/FormDateField";
import { getAllSalesRepresentative } from "../../salesrepresentativeassign/services/salesRepresentative.services";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import { ISalesRepresentative } from "../../salesrepresentativeassign/salesRepresentativeModel";
import { sumBy } from "lodash";
import { useNavigate } from "react-router-dom";
import IconButton from "../../../components/common/IconButton";
import { FiEdit } from "react-icons/fi";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const ChangeWatcher = ({ formRenderProps }: FormChangeWatcherProps) => {
  useEffect(() => {
    formRenderProps.onChange("abcd", { value: "forenable" });
  }, []);

  return null;
};

const ExpenseSummaryReportForm: React.FC = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.reports.loading);

  const ExpenseSummaryReportDetails = useAppSelector(
    (state) => state.reports.ExpenseSummaryReportDetails
  );
  const ExpenseSummaryReportList = useAppSelector(
    (state) => state.reports.ExpenseSummaryReportList
  );
  const SalesRepresentativeList = useAppSelector(
    (state) => state.salesrepresentative.SalesRepresentativeList
  );
  const isEditRef = React.useRef(false);
  //   const currentPage = useAppSelector((state) => state.pagination.currentPage);
  //   const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  useEffect(() => {
    dispatch(getAllSalesRepresentative());
    return () => {
      if (!isEditRef.current) {
        dispatch(clearExpenseSummaryReportDetails());
        dispatch(clearExpenseSummaryReportList());
      }
      //   dispatch(setCurrentPage(0));
    };
  }, []);
  const handleSubmit = async (values: any) => {
    const payload = {
      sr_id: +values?.sr_id,
      from_date: values?.from_date
        ? moment(values?.from_date).format("YYYY-MM-DD")
        : "",
      to_date: values?.to_date
        ? moment(values?.to_date).format("YYYY-MM-DD")
        : "",
    };
    dispatch(
      setExpenseSummaryReport({
        sr_id: +values?.sr_id,
        from_date: values?.from_date,
        to_date: values?.to_date,
      })
    );
    await dispatch(getAllExpenseSummaryReport(payload));
  };

  return (
    <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
      <GridLayoutItem>
        <ShadowCard>
          <Form
            initialValues={ExpenseSummaryReportDetails}
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                  ]}
                >
                  <ChangeWatcher formRenderProps={formRenderProps} />
                  <GridLayoutItem colSpan={4}>
                    <Typography.h4
                      style={{ marginBottom: 0, marginLeft: "3px" }}
                    >
                      Expense Summary Report
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem style={{ width: "100%" }}>
                    <Field
                      name="sr_id"
                      label={"Sales Representative"}
                      placeholder="Select Sales Representative"
                      component={FormSelectionField}
                      validator={requiredValidator}
                      astrike={true}
                      options={SalesRepresentativeList?.map(
                        (expensetype: ISalesRepresentative) => {
                          return {
                            value: expensetype?.id,
                            label: `${expensetype?.first_name} ${expensetype?.middle_name} ${expensetype?.last_name}`,
                          };
                        }
                      )}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name="from_date"
                      label="From Date"
                      format={"dd/MM/yyyy"}
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name="to_date"
                      label="To Date"
                      format={"dd/MM/yyyy"}
                      minDate={
                        formRenderProps.valueGetter("from_date") ||
                        new Date(1900, 1, 1)
                      }
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <div style={{ marginTop: "35px" }}>
                      <ButtonWithLoading
                        label={"View"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                    </div>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            )}
          />
        </ShadowCard>
        {loading ? (
          <LoadingPanel gridRef={gridRef} />
        ) : (
          ExpenseSummaryReportList &&
          ExpenseSummaryReportList.length > 0 && (
            <ShadowCard style={{ marginTop: 10, minHeight: "30vh" }}>
              <ExpenseSummaryExportTable isEditRef={isEditRef} />
            </ShadowCard>
          )
        )}
      </GridLayoutItem>
    </GridLayout>
  );
};

const ExpenseSummaryExportTable: React.FC<{
  isEditRef: React.MutableRefObject<boolean>;
}> = ({ isEditRef }) => {
  const isExcelAccess = checkAcessRights(
    location.pathname,
    EXCEL_EXPORT_ACCESS
  );
  const ExpenseSummaryReportList = useAppSelector(
    (state) => state.reports.ExpenseSummaryReportList
  );
  const ExpenseSummaryReportDetails = useAppSelector(
    (state) => state.reports.ExpenseSummaryReportDetails
  );
  const isEditAccess = checkAcessRights("/srexpenses", EDIT_ACCESS);
  const navigate = useNavigate();

  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);
  const handlePrint = (props: any, type: string) => {
    const state = {
      sr_id: props?.sr_id,
      from_date: props?.from_date
        ? moment(props?.from_date).format("YYYY-MM-DD")
        : "",
      to_date: props?.to_date
        ? moment(props?.to_date).format("YYYY-MM-DD")
        : "",
      initialValues: props.initialValues,
    };

    if (type === "expensesummaryreport") {
      sessionStorage.setItem(
        "expensesummaryreportState",
        JSON.stringify(state)
      );
      const reportTab = window.open("/expensesummaryreportprint", "_blank");
      const interval = setInterval(() => {
        if (reportTab?.closed) {
          sessionStorage.removeItem("expensesummaryreportState");
          clearInterval(interval);
        }
      }, 1000);
    }
  };

  const handleExportExcel = () => {
    /*===*===* YOUR TABLE *===*===*/
    const table = document.querySelector(
      ".employee-details-report-table"
    ) as HTMLTableElement;
    if (!table) return;
    const workbook = new ExcelJS.Workbook();
    /*===*===* YOUR SHEET NAME *===*===*/
    const worksheet = workbook.addWorksheet(
      `${ExpenseSummaryReportList[0]?.sr_name}`
    );
    const rows = Array.from(table.querySelectorAll("tr"));
    let excelRowIndex = 1; // Excel row index (1-based)
    const occupiedCells: Record<string, boolean> = {}; // Track occupied cells
    const colWidths: number[] = [];

    rows.forEach((row, rowIndex) => {
      const cells = Array.from(row.children) as HTMLTableCellElement[];
      let colIndex = 1; // Reset to first column for each row

      cells.forEach((cell) => {
        const cellContent = cell.textContent?.trim() || "";
        const cellLength = cellContent.length;
        const colSpan = cell.colSpan || 1;
        const rowSpan = cell.rowSpan || 1;

        colWidths[colIndex] = Math.max(
          colWidths[colIndex] || 10,
          cellLength + 2
        );
        /*===*===* Find the next available column (skip occupied columns) *===*===*/
        while (occupiedCells[`${excelRowIndex}-${colIndex}`]) {
          colIndex++;
        }
        /*===*===* SET VALUE AND TABLE STYLE *===*===*/
        const excelCell = worksheet.getRow(excelRowIndex).getCell(colIndex);
        const numericValue = Number(cellContent.replace(/,/g, ""));
        if (
          !isNaN(numericValue) &&
          cellContent.replace(/,/g, "").match(/^\d+(\.\d+)?$/)
        ) {
          excelCell.value = numericValue; // Store as a real number
        } else {
          excelCell.value = cellContent; // Store as text
        }
        // excelCell.value = cellContent;
        excelCell.alignment = { horizontal: "center", vertical: "middle" };
        excelCell.border = {
          top: { style: "thin", color: { argb: "000000" } },
          bottom: { style: "thin", color: { argb: "000000" } },
          left: { style: "thin", color: { argb: "000000" } },
          right: { style: "thin", color: { argb: "000000" } },
        };

        /*===*===* HEADER STYLE *===*===*/
        if (rowIndex === 0) {
          excelCell.font = { bold: true };
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "ffabab" },
          };
        }
        /*===*===* LAST ROW STYLE *===*===*/
        if (rowIndex === rows.length - 1) {
          excelCell.font = { bold: true };
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "D9E1F2" },
          };
        }
        /*===*===* HANDEL colSpan AND rowSpan *===*===*/
        if (colSpan > 1 || rowSpan > 1) {
          const startCell = worksheet
            .getRow(excelRowIndex)
            .getCell(colIndex).address;
          const endCell = worksheet
            .getRow(excelRowIndex + rowSpan - 1)
            .getCell(colIndex + colSpan - 1).address;
          worksheet.mergeCells(`${startCell}:${endCell}`);
          // Mark merged cells as occupied
          for (let r = 0; r < rowSpan; r++) {
            for (let c = 0; c < colSpan; c++) {
              occupiedCells[`${excelRowIndex + r}-${colIndex + c}`] = true;
            }
          }
        }
        colIndex += colSpan;
      });

      excelRowIndex++; // Move to next row
    });

    worksheet.columns = colWidths.map((width) => ({ width }));
    /*===*===* SAVE THE FILE  *===*===*/
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(
        blob,
        `Expense Summary Report-${
          ExpenseSummaryReportList[0]?.sr_name
        }-${moment().format("DD-MM-YYYY_hh-mm-A")}.xlsx`
      );
    });
  };

  const [showfilterColumns, setShowFilterColumns] = React.useState(false);
  const initialValues = {
    filter_columns: [
      "expense_date",
      "status",
      "from_city_name",
      "to_city_name",
      "kms_travelled",
      "mode_of_transport_name",
      "Working_agent_town_name",
      "city_town_visited_name",
      "fare_for_transport",
      "fare_transport_allowance_value",
      "courier_post_expense_value",
      "stationary_xerox_expense_value",
      "daily_allowances_hq_value",
      "night_halt_value",
      "petro_expense_per_km_value",
      "other_expense_value",
      "da_up_country_more_than_50_km_value",
      "night_journey_value",
      "net_amount",
      "disallowed_amount",
      "additional_expense_amount",
      "total_expense",
      "sales_amount",
    ],
  };
  const columns = [
    { label: "Expense Date", value: "expense_date" },
    { label: "Status", value: "status" },
    { label: "From City", value: "from_city_name" },
    { label: "To City ", value: "to_city_name" },
    { label: "KMs Travelled", value: "kms_travelled" },
    { label: "Mode of Transport", value: "mode_of_transport_name" },
    { label: "Working Agent Town", value: "Working_agent_town_name" },
    { label: "City/Town Visited", value: "city_town_visited_name" },
    { label: "Fare for Transport", value: "fare_for_transport" },

    { label: "Transport Allowance", value: "fare_transport_allowance_value" },
    { label: "Courier/Post Expense", value: "courier_post_expense_value" },
    {
      label: "Stationary/Xerox Expense",
      value: "stationary_xerox_expense_value",
    },
    { label: "Daily Allowance HQ", value: "daily_allowances_hq_value" },
    { label: "Night Halt", value: "night_halt_value" },
    { label: "Petrol Expense Per KM", value: "petro_expense_per_km_value" },
    { label: "Other Expense", value: "other_expense_value" },
    {
      label: "DA Up Country More Than 50KM",
      value: "da_up_country_more_than_50_km_value",
    },
    { label: "Night Journey", value: "night_journey_value" },
    { label: "Total Amount", value: "net_amount" },
    { label: "Disallowed Amount", value: "disallowed_amount" },
    { label: "Additional Expense Amount", value: "additional_expense_amount" },
    { label: "Total Expense", value: "total_expense" },
    { label: "Sales Amount", value: "sales_amount" },
  ];

  const checkInclude = (key: string, formRenderProps: FormRenderProps) => {
    return formRenderProps.valueGetter("filter_columns")?.includes(key);
  };

  return (
    <>
      {ExpenseSummaryReportList && ExpenseSummaryReportList.length ? (
        <Form
          initialValues={initialValues}
          render={(formRenderProps: FormRenderProps) => {
            return (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  //   style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  <GridLayoutItem className="d-flex justify-content-between align-items-center">
                    <Typography.h4 className="m-0">
                      Expense Summary Report
                      <>
                        <p
                          style={{
                            fontSize: 16,
                            lineHeight: "24px",
                            margin: 0,
                          }}
                        >
                          Name :-{" "}
                          {ExpenseSummaryReportList[0]?.sr_name?.toUpperCase()}{" "}
                          | For Period :-{" "}
                          {ExpenseSummaryReportDetails.from_date &&
                            ExpenseSummaryReportDetails.to_date &&
                            `( ${moment(
                              ExpenseSummaryReportDetails.from_date
                            ).format("DD/MM/YYYY")} - ${moment(
                              ExpenseSummaryReportDetails.to_date
                            ).format("DD/MM/YYYY")} )`}{" "}
                          | Amount Of Bill :-{" "}
                          {formatIndianNumber(
                            ExpenseSummaryReportList[0]?.net_amount
                          )}{" "}
                          | Net Amount Settled :-{" "}
                          {formatIndianNumber(
                            ExpenseSummaryReportList[0]?.total_amount
                          )}
                        </p>
                      </>
                    </Typography.h4>
                    <div className="position-relative d-flex">
                      {isPrintAccess && (
                        <Button
                          style={{ marginRight: 5 }}
                          type="button"
                          fillMode={"solid"}
                          themeColor={"primary"}
                          onClick={() =>
                            handlePrint(
                              {
                                ...ExpenseSummaryReportDetails,
                                initialValues: {
                                  filter_columns:
                                    formRenderProps.valueGetter(
                                      "filter_columns"
                                    ),
                                },
                              },
                              "expensesummaryreport"
                            )
                          }
                        >
                          Print
                        </Button>
                      )}
                      {isExcelAccess && (
                        <Button
                          type="button"
                          fillMode={"solid"}
                          themeColor={"primary"}
                          onClick={handleExportExcel}
                          style={{ marginRight: 10 }}
                        >
                          Excel Export
                        </Button>
                      )}
                      <Tooltip
                        anchorElement="target"
                        position="left"
                        parentTitle={true}
                      >
                        <Button
                          title="Filter Columns"
                          type="button"
                          themeColor={"primary"}
                          fillMode={"solid"}
                          onClick={() => setShowFilterColumns(true)}
                        >
                          Filter
                          <BsThreeDotsVertical />
                        </Button>
                      </Tooltip>
                      {showfilterColumns && (
                        <div
                          style={{
                            position: "absolute",
                            top: "32px",
                            right: "0",
                            background: "white",
                            padding: "12px",
                            border: "1px solid whitesmoke",
                            width: "250px",
                            zIndex: 1,
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-baseline">
                            <p className="m-0 fw-600">Filter</p>
                            <Button
                              themeColor={"primary"}
                              fillMode={"flat"}
                              onClick={() => setShowFilterColumns(false)}
                            >
                              <RxCross2 />
                            </Button>
                          </div>
                          <hr className="m-1" style={{ color: "lightgray" }} />
                          <Field
                            wrapperClassName="d-flex flex-column checkBoxGroup-vertical"
                            inputClassName="checkBoxGroup-vertical-input"
                            id={"filter_columns"}
                            name={"filter_columns"}
                            marginRight={0}
                            marginBeetween={8}
                            component={FormCheckboxGroup}
                            options={columns}
                          />
                        </div>
                      )}
                    </div>
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      maxHeight: "calc(100vh - 340px)",
                      overflow: "scroll",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <table
                      cellSpacing={1}
                      cellPadding={2}
                      className="table table-bordered w-100  employee-details-report-table"
                      style={{
                        marginTop: 1,
                      }}
                    >
                      <thead>
                        <tr
                          className="text-center fw-600"
                          style={{
                            fontSize: 12,
                            position: "sticky",
                            top: 0,
                          }}
                        >
                          {checkInclude("expense_date", formRenderProps) && (
                            <th style={{ minWidth: 180 }}>Date</th>
                          )}
                          {checkInclude("status", formRenderProps) && (
                            <th style={{ minWidth: 150 }}>Status</th>
                          )}
                          {checkInclude("from_city_name", formRenderProps) && (
                            <th style={{ minWidth: 150 }}>From City</th>
                          )}
                          {checkInclude("to_city_name", formRenderProps) && (
                            <th style={{ minWidth: 150 }}>To City</th>
                          )}
                          {checkInclude("kms_travelled", formRenderProps) && (
                            <th style={{ minWidth: 150 }}>Km.</th>
                          )}
                          {checkInclude(
                            "mode_of_transport_name",
                            formRenderProps
                          ) && (
                            <th style={{ minWidth: 150 }}>Mode Of Transport</th>
                          )}
                          {checkInclude(
                            "Working_agent_town_name",
                            formRenderProps
                          ) && (
                            <th style={{ minWidth: 150 }}>
                              Working Agent / Distributor
                            </th>
                          )}
                          {checkInclude(
                            "city_town_visited_name",
                            formRenderProps
                          ) && (
                            <th style={{ minWidth: 150 }}>City/Twon Visited</th>
                          )}
                          {checkInclude(
                            "fare_for_transport",
                            formRenderProps
                          ) && (
                            <th style={{ minWidth: 150 }}>
                              Fare For Transport
                            </th>
                          )}
                          {checkInclude(
                            "fare_transport_allowance_value",
                            formRenderProps
                          ) && (
                            <th style={{ minWidth: 150 }}>
                              FARE/TRANSPORTATION ALLOWANCE (TA)
                            </th>
                          )}
                          {checkInclude(
                            "courier_post_expense_value",
                            formRenderProps
                          ) && (
                            <th style={{ minWidth: 150 }}>
                              COURIER/POST EXPENSES
                            </th>
                          )}
                          {checkInclude(
                            "stationary_xerox_expense_value",
                            formRenderProps
                          ) && (
                            <th style={{ minWidth: 150 }}>
                              STATIONARY/XEROX EXPENSES
                            </th>
                          )}
                          {checkInclude(
                            "daily_allowances_hq_value",
                            formRenderProps
                          ) && (
                            <th style={{ minWidth: 150 }}>
                              DAILY ALLOWANCES HQ (DA)
                            </th>
                          )}
                          {checkInclude(
                            "night_halt_value",
                            formRenderProps
                          ) && <th style={{ minWidth: 150 }}>NIGHT HALT</th>}
                          {checkInclude(
                            "petro_expense_per_km_value",
                            formRenderProps
                          ) && (
                            <th style={{ minWidth: 150 }}>
                              PETROL EXPENSES PER KM
                            </th>
                          )}
                          {checkInclude(
                            "other_expense_value",
                            formRenderProps
                          ) && (
                            <th style={{ minWidth: 150 }}>
                              OTHER EXPENSE(MISC. EXP)
                            </th>
                          )}
                          {checkInclude(
                            "da_up_country_more_than_50_km_value",
                            formRenderProps
                          ) && (
                            <th style={{ minWidth: 150 }}>
                              DA UP COUNTRY MORE THAN 50 KM
                            </th>
                          )}
                          {checkInclude(
                            "night_journey_value",
                            formRenderProps
                          ) && <th style={{ minWidth: 150 }}>NIGHT JOURNEY</th>}
                          {checkInclude("net_amount", formRenderProps) && (
                            <th style={{ minWidth: 150 }}>Total Amount</th>
                          )}
                          {checkInclude(
                            "disallowed_amount",
                            formRenderProps
                          ) && (
                            <th style={{ minWidth: 150 }}>
                              Total Disallowed Amount.
                            </th>
                          )}
                          {checkInclude(
                            "additional_expense_amount",
                            formRenderProps
                          ) && (
                            <th style={{ minWidth: 150 }}>
                              Total Additional Expense
                            </th>
                          )}
                          {checkInclude("total_expense", formRenderProps) && (
                            <th style={{ minWidth: 150 }}>Total Expense</th>
                          )}
                          {checkInclude("sales_amount", formRenderProps) && (
                            <th style={{ minWidth: 150 }}>Sales Amount</th>
                          )}
                        </tr>
                      </thead>
                      {/* Table Body */}
                      <tbody>
                        {ExpenseSummaryReportList[0].expense_summary_value_details.map(
                          (item: any, rowIndex: number) => (
                            <>
                              <tr key={rowIndex}>
                                {checkInclude(
                                  "expense_date",
                                  formRenderProps
                                ) && (
                                  <td>
                                    {isEditAccess && (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {moment(
                                          item?.expense_date,
                                          "DD/MM/YYYY"
                                        ).format("DD-MMM-YYYY")}
                                        <IconButton
                                          type="button"
                                          fillMode="flat"
                                          themeColor={"primary"}
                                          size="small"
                                          style={{
                                            padding: "15px",
                                            marginLeft: "5px",
                                          }}
                                          onClick={() => {
                                            isEditRef.current = true;
                                            navigate("/srexpense/verify", {
                                              state: {
                                                expense_details_guid:
                                                  item?.expense_details_guid,
                                                isreport: true,
                                              },
                                            });
                                          }}
                                        >
                                          <FiEdit
                                            className="absolute-position"
                                            style={{
                                              fontSize: "20px",
                                              zIndex: 0,
                                              color: "red",
                                            }}
                                          />
                                        </IconButton>
                                      </div>
                                    )}
                                  </td>
                                )}
                                {checkInclude("status", formRenderProps) && (
                                  <td>
                                    <div
                                      style={{
                                        textAlign: "center",
                                        marginTop: "5px",
                                      }}
                                    >
                                      {item?.status ? (
                                        <span
                                          style={{
                                            backgroundColor: "#D1FADF",
                                            color: "#065032",
                                            padding: "3px 10px",
                                            textTransform: "capitalize",
                                            borderRadius: "10px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          Verified
                                        </span>
                                      ) : (
                                        <span
                                          style={{
                                            backgroundColor:
                                              "rgb(254, 240, 199)",
                                            color: "rgb(128, 55, 23)",
                                            padding: "3px 10px",
                                            textTransform: "capitalize",
                                            borderRadius: "10px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          Pending
                                        </span>
                                      )}
                                    </div>
                                  </td>
                                )}
                                {checkInclude(
                                  "from_city_name",
                                  formRenderProps
                                ) && <td>{item?.from_city_name}</td>}
                                {checkInclude(
                                  "to_city_name",
                                  formRenderProps
                                ) && <td>{item?.to_city_name}</td>}
                                {checkInclude(
                                  "kms_travelled",
                                  formRenderProps
                                ) && <td>{item?.kms_travelled}</td>}
                                {checkInclude(
                                  "mode_of_transport_name",
                                  formRenderProps
                                ) && <td>{item?.mode_of_transport_name}</td>}
                                {checkInclude(
                                  "Working_agent_town_name",
                                  formRenderProps
                                ) && <td>{item?.Working_agent_town_name}</td>}
                                {checkInclude(
                                  "city_town_visited_name",
                                  formRenderProps
                                ) && <td>{item?.city_town_visited_name}</td>}
                                {checkInclude(
                                  "fare_for_transport",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.fare_for_transport || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "fare_transport_allowance_value",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.fare_transport_allowance_value || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "courier_post_expense_value",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.courier_post_expense_value || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "stationary_xerox_expense_value",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.stationary_xerox_expense_value || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "daily_allowances_hq_value",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.daily_allowances_hq_value || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "night_halt_value",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.night_halt_value || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "petro_expense_per_km_value",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.petro_expense_per_km_value || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "other_expense_value",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.other_expense_value || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "da_up_country_more_than_50_km_value",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.da_up_country_more_than_50_km_value ||
                                        0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "night_journey_value",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.night_journey_value || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "net_amount",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.net_amount || 0)}
                                  </td>
                                )}

                                {checkInclude(
                                  "disallowed_amount",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.disallowed_amount || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "additional_expense_amount",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.additional_expense_amount || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "total_expense",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.total_expense || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "sales_amount",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.sales_amount || 0
                                    )}
                                  </td>
                                )}
                              </tr>
                            </>
                          )
                        )}
                        {/* Total Row */}
                        <tr style={{ fontWeight: "bold" }}>
                          {checkInclude("expense_date", formRenderProps) && (
                            <td>Total</td>
                          )}
                          {checkInclude("status", formRenderProps) && <td></td>}
                          {checkInclude("from_city_name", formRenderProps) && (
                            <td></td>
                          )}
                          {checkInclude("to_city_name", formRenderProps) && (
                            <td></td>
                          )}
                          {checkInclude("kms_travelled", formRenderProps) && (
                            <td></td>
                          )}
                          {checkInclude(
                            "mode_of_transport_name",
                            formRenderProps
                          ) && <td></td>}
                          {checkInclude(
                            "Working_agent_town_name",
                            formRenderProps
                          ) && <td></td>}
                          {checkInclude(
                            "city_town_visited_name",
                            formRenderProps
                          ) && <td></td>}
                          {checkInclude(
                            "fare_for_transport",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "fare_for_transport"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "fare_transport_allowance_value",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "fare_transport_allowance_value"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "courier_post_expense_value",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "courier_post_expense_value"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "stationary_xerox_expense_value",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "stationary_xerox_expense_value"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "daily_allowances_hq_value",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "daily_allowances_hq_value"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "night_halt_value",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "night_halt_value"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "petro_expense_per_km_value",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "petro_expense_per_km_value"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "other_expense_value",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "other_expense_value"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "da_up_country_more_than_50_km_value",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "da_up_country_more_than_50_km_value"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "night_journey_value",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "night_journey_value"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude("net_amount", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "net_amount"
                                )
                              )}
                            </td>
                          )}

                          {checkInclude(
                            "disallowed_amount",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "disallowed_amount"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "additional_expense_amount",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "additional_expense_amount"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude("total_expense", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "total_expense"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude("sales_amount", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "sales_amount"
                                )
                              )}
                            </td>
                          )}
                        </tr>
                      </tbody>
                    </table>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            );
          }}
        />
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default ExpenseSummaryReportForm;
